(() => {
  const INIT_ATTR = 'data-dropdown-init';

  const get = (root) => {
    const form = root.closest('form');
    const isLanguage = root.hasAttribute('data-language-dropdown');
    const hidden = form
      ? form.querySelector(isLanguage ? 'input[name="language_code"]' : 'input[name="country_code"]')
      : null;
    const btn =
      root.querySelector(isLanguage ? '[data-language-dropdown-trigger]' : '[data-country-dropdown-trigger]') ||
      root.querySelector('button');
    const list =
      root.querySelector(isLanguage ? '[data-language-dropdown-list]' : '[data-country-dropdown-list]') ||
      root.querySelector('ul');
    return { form, hidden, btn, list };
  };

  const getAllRoots = () =>
    Array.from(document.querySelectorAll('[data-country-dropdown], [data-language-dropdown]'));

  const closeRoot = (root) => {
    const { btn, list } = get(root);
    if (list) {
      list.hidden = true;
      list.style.maxHeight = '';
      list.classList.remove('header__country-list--open-up', 'advertorial-footer__country-list--open-up');
    }
    if (btn) btn.setAttribute('aria-expanded', 'false');
  };

  const closeAll = () => getAllRoots().forEach(closeRoot);

  const updatePlacement = (btn, list) => {
    if (!btn || !list || list.hidden) return;

    const rect = btn.getBoundingClientRect();
    const gap = 4;
    const maxH = 240;
    const listH = Math.min(maxH, list.scrollHeight);
    const spaceBelow = window.innerHeight - rect.bottom - gap;
    const spaceAbove = rect.top - gap;

    list.style.maxHeight = '';
    list.classList.remove('header__country-list--open-up', 'advertorial-footer__country-list--open-up');

    const openUpClass = list.classList.contains('advertorial-footer__country-list')
      ? 'advertorial-footer__country-list--open-up'
      : 'header__country-list--open-up';

    if (spaceBelow >= listH) return;
    if (spaceAbove >= listH) {
      list.classList.add(openUpClass);
      return;
    }
    if (spaceAbove > spaceBelow) {
      list.classList.add(openUpClass);
      list.style.maxHeight = `${Math.max(80, spaceAbove)}px`;
    } else {
      list.style.maxHeight = `${Math.max(80, spaceBelow)}px`;
    }
  };

  const updateAllOpenPlacements = () => {
    getAllRoots().forEach((root) => {
      const { btn, list } = get(root);
      if (btn && list && !list.hidden) updatePlacement(btn, list);
    });
  };

  let placementRaf = null;
  const schedulePlacementUpdate = () => {
    if (placementRaf) return;
    placementRaf = requestAnimationFrame(() => {
      placementRaf = null;
      updateAllOpenPlacements();
    });
  };

  const initCountryDropdowns = (container = document) => {
    const scope = container && typeof container.querySelectorAll === 'function' ? container : document;
    const selector = `[data-country-dropdown]:not([${INIT_ATTR}]), [data-language-dropdown]:not([${INIT_ATTR}])`;
    const roots = Array.from(scope.querySelectorAll(selector));

    roots.forEach((root) => {
      const { form, hidden, btn, list } = get(root);
      if (!form || !hidden || !btn || !list) return;

      root.setAttribute(INIT_ATTR, '');

      const open = () => {
        list.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => updatePlacement(btn, list));
      };

      const close = () => closeRoot(root);

      const toggle = () => {
        if (list.hidden) {
          closeAll();
          open();
        } else {
          close();
        }
      };

      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        toggle();
      });

      root.addEventListener('click', (e) => e.stopPropagation());

      list.querySelectorAll('[data-value]').forEach((li) => {
        li.addEventListener('click', (e) => {
          e.stopPropagation();
          const v = li.getAttribute('data-value');
          if (!v) return;
          if (v === hidden.value) {
            close();
            return;
          }
          hidden.value = v;
          form.submit();
        });
      });
    });
  };

  document.addEventListener('click', closeAll);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
  window.addEventListener('resize', schedulePlacementUpdate);
  window.addEventListener('scroll', schedulePlacementUpdate, true);

  initCountryDropdowns();

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) initCountryDropdowns(event.target);
  });
})();
